import axios from 'axios';
import { angularService, getAuthHeader } from '../../../../../utils';
import { getComponents } from '../../../../modules/Components/api/components';

const FALLBACK_URL = 'https://ms.dev.staging-zorallabs.com/api/navigation/search';

export type Entity = {
  entityType: string,
  entityName: string,
  entityVersion?: number
}

const getData = async ({ entityType, entityName, entityVersion = 0 }: Entity) => {
  const zStatus = angularService('zStatus');
  const URL = zStatus && zStatus.endpoint && zStatus.endpoint.de
    ? zStatus.endpoint.de + '/navigation/search'
    : FALLBACK_URL;

  let metadata: any = {};

  if (entityType === 'Signal' || entityType === 'Component') {
    metadata['componentList'] = await getComponents();
  }

  return axios
    .get(URL, { params: { entityType, entityName, entityVersion }, headers: getAuthHeader() })
    .then(res => ({ data: res.data, metadata }));
};

export default getData;
